export default __webpack_public_path__ + "static/media/ash-back.4a8d3927.png";